import { LoadingDialog } from '@/components/controls';
import { addDays, startOfDay } from 'date-fns';
import { useMemo } from 'react';
import { NoticeEditorDialog } from './NoticeEditorDialog';
import { useDeleteNotice } from './useDeleteNotice';
import { useNotice } from './useNotice';
import { useUpsertNotice } from './useUpsertNotice';

export function NoticeEditor({ code, isOpen, onClose, groupCodes }) {
  const today = startOfDay(new Date()).toISOString();
  const defaultNotice = useMemo(
    () => ({
      expiryDate: addDays(new Date(today), 10),
      groupCodes: groupCodes ?? [],
      title: '',
      nominalIds: [],
      contentHTML: '',
    }),
    [groupCodes, today],
  );
  const {
    query: { data: fetchedNotice },
  } = useNotice(code);
  const notice = code === 'new' ? defaultNotice : fetchedNotice;
  const { mutateAsync: upsertNotice } = useUpsertNotice();
  const { mutate: deleteNotice, isPending: isDeleting } = useDeleteNotice();

  async function handleClose(values) {
    if (values) {
      await upsertNotice(values);
    }

    onClose();
  }

  function handleDelete() {
    deleteNotice(code);

    onClose();
  }

  return notice ? (
    <NoticeEditorDialog
      notice={notice}
      isOpen={isOpen}
      onClose={handleClose}
      onDelete={handleDelete}
      isDeleting={isDeleting}
    />
  ) : (
    <LoadingDialog isOpen={isOpen} />
  );
}
